import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DiagnoseCheckListBymappingId } from 'projects/Administration/src/app/business-entities/diagnose-check-list-model';
import { GenericResponse } from 'projects/Administration/src/app/business-entities/generic-response';
import { DiagnoseCheckListBusinessService } from 'projects/Administration/src/app/business-services/diagnose-check-list.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-add-diagnose-check-list',
  templateUrl: './add-diagnose-check-list.component.html'
})
export class AddDiagnoseCheckListComponent implements OnInit {
  condition:boolean = false
  addDiagnoseCheckListForm: FormGroup;
  checkListId: number;
  diagnoseCheckListByMappingId:DiagnoseCheckListBymappingId[]=[];
  languageList: any[];
  selectedServices: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private baseService: BaseService,
    private diagnoseService: DiagnoseCheckListBusinessService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private activeModal : NgbActiveModal,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
    private cookieservice: CookieService
  ) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.addDiagnoseCheckListForm = this.formBuilder.group({
      Service: new FormArray([]),
      Sequence: [null,[Validators.min(1), Validators.max(99)]],
      IsActive: [true]
    });
    this.getLanguage();
    this.checkListId = this.diagnoseService.diagnoseId
    if(this.checkListId > 0)
    {
        this.condition = true;
        this.getDiagnoseCheckListByMappingId(this.checkListId);
        this.GetServicesForDiagnoseChecklist();
    }
  }

  get t() { return this.cpf.Service as FormArray; }

 
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t?.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }

  get cpf() {
    return this.addDiagnoseCheckListForm.controls;
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
  GetServicesForDiagnoseChecklist(){
    let language = this.cookieservice.get('userSelectedLanguage')
    this.diagnoseService.GetServicesForDiagnoseChecklist(language,this.checkListId).then(response => {
    this.selectedServices = response.responseObject;
    })
  }
  onSubmit()
  {
    const number = this.currentLanguageService.LanguageList.length;
    if( this.addDiagnoseCheckListForm?.value){
      if(this.addDiagnoseCheckListForm.value.Service && this.addDiagnoseCheckListForm.value.Service.length === number && this.addDiagnoseCheckListForm.value.Sequence?.toString().trim()){
        let title = this.addDiagnoseCheckListForm.value.Service.map(x=>
          {
            if(!x.name?.trim()){
              return x;
            }
            else{
              x.name = x.name.trim()
            }
          });
        if(title && title.length > 0){
        let validTitle = title.filter(x=> x !== undefined)
        if(validTitle && validTitle.length > 0)
        {
          let msg = this.translate.instant("lblPleaseEnterValidValue");
          this.toaster.error(msg)
        }
        else{
          this.CheckListItem()
        }
        }
        else{
          this.CheckListItem()
        }
      }
      else{
        let msg = this.translate.instant("lblPleaseEnterValidValue");
        this.toaster.error(msg)
      }
    }
  }
  // onSubmit() {
  //   const number = this.currentLanguageService.LanguageList.length;
  //   const formValue = this.addDiagnoseCheckListForm?.value;
  
  //   if (!formValue) {
  //     return;
  //   }
  
  //   const { Service, Sequence } = formValue;
  
  //   if (Service?.length !== number || !Sequence?.toString().trim()) {
  //     const msg = this.translate.instant("lblPleaseEnterValidValue");
  //     this.toaster.error(msg);
  //     return;
  //   }
  
  //   const trimmedService = Service.map(x => {
  //     if (x.name) {
  //       x.name = x.name.trim();
  //     }
  //     return x;
  //   });
  
  //   const validTitles = trimmedService.filter(x => x.name);
  
  //   if (validTitles.length > 0) {
  //     const msg = this.translate.instant("lblPleaseEnterValidValue");
  //     this.toaster.error(msg);
  //   } else {
  //     this.CheckListItem();
  //   }
  // }
  CheckListItem(){
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.userId;

    if(this.checkListId > 0)
    {
      let viewModel={
        UpdatedBy: currentUser,
        MappingId: this.checkListId,
        Lnlnvalue: this.addDiagnoseCheckListForm.value.Service,
        IsActive:this.addDiagnoseCheckListForm.value.IsActive,
        Sequence:this.addDiagnoseCheckListForm.value.Sequence,
      }
      this.diagnoseService.editDiagnoseCheckList(viewModel).then((response: GenericResponse<any>) => {
        if(response.responseObject === true)
        {
          let successMsg = this.translate.instant("lblCheckListUpdated");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true
          });
        }
        else{
          this.toaster.error("error")
        }
        this.spinner.hide();
      });
    }
    else{
      let viewModel={
        CreatedBy: currentUser,
        MappingId: this.checkListId,
        Lnlnvalue: this.addDiagnoseCheckListForm.value.Service,
        IsActive:this.addDiagnoseCheckListForm.value.IsActive,
        Sequence:this.addDiagnoseCheckListForm.value.Sequence,
      }
      this.diagnoseService.addDiagnoseCheckList(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          let successMsg = this.translate.instant("lblCheckListAdded");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true
          });
          this.spinner.hide();
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          let successMsg = this.translate.instant("lblCheckListAlredyAdded");
          this.toaster.warning(successMsg);
        }
      })
      this.spinner.hide();
    }
  }
  getDiagnoseCheckListByMappingId(id:number)
  {
    this.spinner.show();
    this.diagnoseService.getDiagnoseCheckListBymappingId(id).then((response) => {
      this.addDiagnoseCheckListForm.reset();
      if(response){
        if (response.responseCode === Constant.SuccessResponseCode && response.responseObject.errorCount === undefined) {
          if (response.responseObject !== undefined) {
            this.addDiagnoseCheckListForm.patchValue({
              Sequence: response.responseObject.diagnoseCheckListByMappingIdVM[0].sequence,
              IsActive: response.responseObject.diagnoseCheckListByMappingIdVM[0].isActive,
              Service: response.responseObject.diagnoseChecklistDetails
            })
          }
        }
      }
    });
    this.spinner.hide()
  }
}
